
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotion/25-3d3",
      function () {
        return require("private-next-pages/promotion/25-3d3.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotion/25-3d3"])
      });
    }
  